import React, {useRef} from 'react';
import {motion, useAnimationFrame, useMotionValue} from 'framer-motion';
import {ArrowLeftIcon, ArrowRightIcon, DevicePhoneMobileIcon} from '@heroicons/react/24/outline';

const MOTION_AMP = 50;
const MOTION_DUR = 2.5;
const MOTION_ARW_MIN = MOTION_AMP * 0.5;
const MOTION_ARW_MAX = MOTION_ARW_MIN + MOTION_AMP * 2;

interface IARUIScan {}

const ARUIScan = ({}: IARUIScan) => {
  const x = useMotionValue(MOTION_AMP);
  const time = useRef(0);

  useAnimationFrame(t => {
    time.current = t * 0.001;
    const offset = MOTION_AMP * Math.cos((time.current * 2 * Math.PI) / MOTION_DUR);
    x.set(offset);
  });

  return (
    <div className="absolute top-38 left-[50%] w-80 transform -translate-x-[50%] flex flex-col gap-4 rounded-2xl p-4 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative">
        <motion.div style={{x}} className="pl-[50%]">
          <DevicePhoneMobileIcon className="size-16 text-white transform -translate-x-[50%]" />
        </motion.div>
        <div className="absolute left-0 top-[50%] flex items-center transform -translate-y-[50%]">
          <ArrowLeftIcon className="size-6 text-white" />
          <motion.div
            animate={{width: [MOTION_ARW_MAX, MOTION_ARW_MIN, MOTION_ARW_MAX]}}
            transition={{duration: MOTION_DUR, repeat: Infinity, ease: 'easeInOut'}}
            className="h-0.5 bg-white -ml-1 origin-left"
          />
        </div>
        <div className="absolute right-0 top-[50%] flex items-center transform -translate-y-[50%]">
          <motion.div
            animate={{width: [MOTION_ARW_MIN, MOTION_ARW_MAX, MOTION_ARW_MIN]}}
            transition={{duration: MOTION_DUR, repeat: Infinity, ease: 'easeInOut'}}
            className="h-0.5 bg-white -mr-1 origin-right"
          />
          <ArrowRightIcon className="size-6 text-white" />
        </div>
      </div>
      <p className="relative text-center text-white text-lg">
        Scan the surrounding until <br />
        the circle turns green
      </p>
    </div>
  );
};

export default React.memo(ARUIScan);
